import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { checkDeploymentEnvironment, checkForServiceWorkers, clearAllCaches } from './lib/deployment-check';

// Check deployment environment and clear any caches on startup
checkDeploymentEnvironment();
checkForServiceWorkers();
clearAllCaches();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);